// ── 비밀번호 초기화 · 퇴직 처리 · 주소 검색 ─────────────────────────────────
//   useUserEdit.js 가 334줄이라 분리했다(2026-09-08). 로직은 그대로 옮겼다.
import { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { todayKST } from '../../../utils/date';
import { toDate, isValidDateText, normalizeDateTextInput } from './utils';

export function useUserLifecycle({ showToast, writeBaseFor, fetchUsers, setForm }) {
  const [deactivateTarget, setDeactivateTarget] = useState(null);
  const [deactivateDate, setDeactivateDate] = useState(todayKST());
  const [deactivateSaving, setDeactivateSaving] = useState(false);

  async function resetPassword(row) {
    if (!window.confirm(`${row.name}의 비밀번호를 0214로 초기화할까요?`)) return;
    const result = await apiClient.post(`${writeBaseFor(row)}/${row.id}/reset-password`, {});
    if (result.ok) {
      showToast(result.data?.message || '비밀번호를 초기화했습니다.', 'success');
    } else {
      showToast(result.data?.message || '비밀번호 초기화에 실패했습니다.', 'error');
    }
  }

  function closeDeactivateModal() {
    if (deactivateSaving) return;
    setDeactivateTarget(null);
    setDeactivateDate(todayKST());
  }

  function deactivate(row) {
    setDeactivateTarget(row);
    setDeactivateDate(toDate(row?.resign_date) || todayKST());
  }

  async function submitDeactivate() {
    if (!deactivateTarget?.id) return;
    const resignDate = normalizeDateTextInput(deactivateDate);
    if (!isValidDateText(resignDate)) {
      showToast('퇴사일자는 YYYY-MM-DD 형식으로 입력해 주세요.', 'error');
      return;
    }
    setDeactivateSaving(true);
    const result = await apiClient.put(`${writeBaseFor(deactivateTarget)}/${deactivateTarget.id}`, { resign_date: resignDate });
    setDeactivateSaving(false);
    if (!result.ok) {
      showToast(result.data?.message || '퇴직 처리에 실패했습니다.', 'error');
      return;
    }
    showToast('퇴직 처리되었습니다.', 'success');
    closeDeactivateModal();
    fetchUsers();
  }

  // ── 주소 검색 (Daum Postcode API) ────────────────────────────────────────
  async function ensureDaumPostcodeScript() {
    if (window.daum?.Postcode) return;
    await new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  async function openAddressSearch() {
    try {
      await ensureDaumPostcodeScript();
      new window.daum.Postcode({
        oncomplete: (data) => {
          const picked = data.roadAddress || data.jibunAddress || '';
          setForm((prev) => ({ ...prev, addressBase: picked }));
        },
      }).open();
    } catch (_e) {
      showToast('주소 검색 스크립트 로드에 실패했습니다.', 'error');
    }
  }

  return {
    deactivateTarget, deactivateDate, setDeactivateDate, deactivateSaving,
    closeDeactivateModal, submitDeactivate, deactivate,
    resetPassword, openAddressSearch,
  };
}
